
import React from "react";

interface AthleteTierDataProps {
  tierData: any;
}

export default function AthleteTierData({ tierData }: AthleteTierDataProps) {
  if (!tierData) return <p className="text-white/70">No tier data available</p>;
  
  return (
    <div className="space-y-3">
      {tierData.sport && (
        <div className="flex">
          <span className="text-white/80 w-40">Sport:</span>
          <span className="text-white">{tierData.sport}</span>
        </div>
      )}
      {tierData.sportLevel && (
        <div className="flex">
          <span className="text-white/80 w-40">Competition Level:</span>
          <span className="text-white">{tierData.sportLevel}</span>
        </div>
      )}
      {tierData.positionRole && (
        <div className="flex">
          <span className="text-white/80 w-40">Position/Role:</span>
          <span className="text-white">{tierData.positionRole}</span>
        </div>
      )}
      {tierData.seasonCycle && (
        <div className="flex">
          <span className="text-white/80 w-40">Season Cycle:</span>
          <span className="text-white">{tierData.seasonCycle.replace(/_/g, " ")}</span>
        </div>
      )}
      {(tierData.seasonCycle === "pre_season" || tierData.seasonCycle === "in_season") && tierData.importantDates && (
        <div className="flex">
          <span className="text-white/80 w-40">Important Dates:</span>
          <span className="text-white">{tierData.importantDates}</span>
        </div>
      )}
      {tierData.sportSpecificGoals && (
        <div className="flex">
          <span className="text-white/80 w-40">Sport Goals:</span>
          <span className="text-white">{tierData.sportSpecificGoals}</span>
        </div>
      )}
      {tierData.keyPerformanceAreas && tierData.keyPerformanceAreas.length > 0 && (
        <div className="flex">
          <span className="text-white/80 w-40">Key Areas:</span>
          <span className="text-white">{tierData.keyPerformanceAreas.map((area: string) => area.replace(/_/g, " ")).join(", ")}</span>
        </div>
      )}
      {tierData.sportTrainingLoad && (
        <div className="flex">
          <span className="text-white/80 w-40">Training Load:</span>
          <span className="text-white">{tierData.sportTrainingLoad}</span>
        </div>
      )}
      {tierData.sportInjuries && (
        <div className="flex">
          <span className="text-white/80 w-40">Sport Injuries:</span>
          <span className="text-white">{tierData.sportInjuries}</span>
        </div>
      )}
      {tierData.recoveryTravel && (
        <div className="flex">
          <span className="text-white/80 w-40">Recovery & Travel:</span>
          <span className="text-white">{tierData.recoveryTravel}</span>
        </div>
      )}
    </div>
  );
}
